import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import {
  Estimate,
  VendorOrder,
} from '../../../../../../shared/models/vendor-order.model';
import { QuoteCardComponent } from '../quote-card/quote-card.component';

@Component({
  selector: 'app-cancelled-estimates-list',
  standalone: true,
  imports: [QuoteCardComponent],
  templateUrl: './cancelled-estimates-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelledEstimatesListComponent {
  readonly order = input.required<VendorOrder>();
  readonly estimates = input.required<Estimate[]>();
  readonly orderDeadline = input<string>();
}
